import { TabPanelUnstyled } from '@mui/base'
import { styled } from '@mui/material'
import useGetTabPanelTemplate
  from '~/src/components/mui-wrappers/styled/delivery-methods/tab-panel/styles/useGetTabPanelTemplate'

const DeliveryMethodTabPanel = styled(TabPanelUnstyled)(() => useGetTabPanelTemplate().getComponentSx())

export default DeliveryMethodTabPanel
